import React, { Component } from 'react';
import { connect } from 'react-redux';

import TextField from 'material-ui/TextField';

import * as landlordInspections from 'actions/landlordInspectionsActions';

import { List, AutoSizer } from 'react-virtualized';

import { InspectionsDropdown, renderStatus } from 'helpers/Inspections';
import { isFilterInStrings } from 'helpers/StringHelper.js';
import { toFriendlyDateString } from 'helpers/Formatter';
import { getFilterText } from 'helpers/Filter';

export default connect(
  store => {
    return {
      inspections: store.landlordInspections.inspections,
    };
  },
  dispatch => {
    return {
      getInspections: () => {
        dispatch(landlordInspections.getInspections());
      },
    };
  }
)(
  class InspectionList extends Component {
    constructor(props) {
      super(props);

      this.state = {
        filterText: '',
      };
    }

    componentDidMount() {
      this.props.getInspections();
    }

    render() {
      const DEFAULT_ROW_HEIGHT = 117;
      const filteredData = this.props.inspections.filter(item =>
        isFilterInStrings([item.unit, item.inspection_type], this.state.filterText)
      );

      const openDocumentPortal = this.props.openDocumentPortal;

      function rowRenderer({ key, index, isScrolling, isVisible, style }) {
        return (
          <div id="mobile_card" key={key} style={style}>
            <div className="row" style={{ marginBottom: '10px' }}>
              <div
                className="tenant_mobile_header"
                style={{ float: 'left', fontSize: '15px !important' }}
              >
                {filteredData[index].unit}
              </div>
              <div
                className="mobile_subheader"
                style={{
                  float: 'right',
                  marginTop: '6px',
                  padding: 0,
                  fontSize: '14px',
                }}
              >
                {' '}
                {filteredData[index].inspection_type} Inspection{' '}
              </div>
            </div>
            <div className="row">
              <div className="mobile_subheader" style={{ float: 'right' }}>
                {' '}
                {renderStatus(filteredData[index].status)}
              </div>
            </div>
            <div className="row">
              <div className="mobile_subheader" style={{ float: 'right' }}>
                {' '}
                {toFriendlyDateString(filteredData[index].date_created)}
              </div>
            </div>
            <div className="row">
              <div className="mobile_subheader" style={{ float: 'right' }}>
                <InspectionsDropdown
                  data={filteredData[index]}
                  openDocumentPortal={openDocumentPortal}
                />
              </div>
            </div>
          </div>
        );
      }

      return (
        <div style={{ height: 'calc(100% - 95px)' }}>
          <div className="stage-header clearfix">
            <span className="page-title">Property Inspection</span>
          </div>

          <div className="row" style={{ marginTop: '-20px' }}>
            <TextField
              hintText="Filter by Inspection"
              style={{ fontSize: '13px' }}
              value={this.state.filterText}
              onChange={e => getFilterText(e, this)}
            />
          </div>

          <AutoSizer>
            {({ height, width }) => (
              <List
                rowCount={filteredData.length}
                rowHeight={DEFAULT_ROW_HEIGHT}
                rowRenderer={rowRenderer}
                width={width}
                height={height}
              />
            )}
          </AutoSizer>
        </div>
      );
    }
  }
);
